import React from "react";
import PropTypes from "prop-types";
import { parse } from "qs";

import { STREAM_TYPE } from "config/constants";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import LatestStories from "components/Library/LatestStories";
import SectionStreamHelmet from "stream/components/SectionStreamHelmet";
import { getLastSeenCookie } from "stream/utils/lastSeenCookie";

export default function SectionStreamWrapper(props) {
  const streamParams = {
    lookup: props.slug,
    type: STREAM_TYPE.SECTION,
    lastSeenId: getLastSeenCookie({
      lookup: props.slug,
      type: STREAM_TYPE.SECTION,
    }),
  };

  const parsedQs = parse(props.location.search.slice(1));

  return (
    <React.Fragment>
      <SectionStreamHelmet slug={streamParams.lookup} />
      <StandardLayout
        main={props.children({ streamParams, parsedQs })}
        complementary={<LatestStories />}
      />
    </React.Fragment>
  );
}

SectionStreamWrapper.propTypes = {
  slug: PropTypes.string.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
  children: PropTypes.func.isRequired,
};
